import React from 'react';
import { Row, Col, Card, Table } from 'react-bootstrap';
import moment from 'moment';

const StudentProfileRecords = ({ student }) => {
    const dobValue = student?.dob || student?.date_of_birth;
    let formattedDob = "—";
    if (dobValue) {
        const parsed = moment(dobValue);
        if (parsed.isValid()) {
            const age = moment().diff(parsed, 'years');
            formattedDob = `${parsed.format('DD MMM YYYY')} (${age} yrs)`;
        } else {
            formattedDob = dobValue;
        }
    }

    return (
        <div>
            <h5 className="mb-4 text-dark font-weight-bold">Profile & Records</h5>
            <Row>
                <Col md={6} className="mb-4">
                    <Card className="border-0 shadow-sm p-4 h-100" style={{ borderRadius: '12px', background: '#f8fafc' }}>
                        <h6 className="font-weight-bold text-secondary mb-3"><i className="fas fa-user-circle mr-2"></i>Personal Info</h6>
                        <Table borderless size="sm">
                            <tbody>
                                <tr><td className="text-muted font-weight-bold pl-0" style={{ width: '40%' }}>Roll No</td><td className="text-dark">: {student?.roll_no || "—"}</td></tr>
                                <tr><td className="text-muted font-weight-bold pl-0">Mobile</td><td className="text-dark">: {student?.contact_no || student?.student_mobile || "—"}</td></tr>
                                <tr><td className="text-muted font-weight-bold pl-0">Branch</td><td className="text-dark">: {student?.branch_name || "—"}</td></tr>
                                <tr><td className="text-muted font-weight-bold pl-0">Class & Section</td><td className="text-dark">: {student?.class_name ? `${student.class_name}${student.section_name ? ` - ${student.section_name}` : ''}` : (student?.section_name || "—")}</td></tr>
                                <tr><td className="text-muted font-weight-bold pl-0">Date of Birth</td><td className="text-dark">: {formattedDob}</td></tr>
                                {/* <tr><td className="text-muted font-weight-bold pl-0">Blood Group</td><td className="text-dark">: {student?.blood_group || student?.bloodGroup || "—"}</td></tr> */}
                                {/* <tr><td className="text-muted font-weight-bold pl-0">Gender</td><td className="text-dark">: {student?.gender || "—"}</td></tr> */}
                                {/* <tr><td className="text-muted font-weight-bold pl-0">Address</td><td className="text-dark">: {student?.address || "—"}</td></tr> */}
                            </tbody>
                        </Table>
                    </Card>
                </Col>
                <Col md={6} className="mb-4">
                    <Card className="border-0 shadow-sm p-4 h-100" style={{ borderRadius: '12px', background: '#f8fafc' }}>
                        <h6 className="font-weight-bold text-secondary mb-3"><i className="fas fa-users mr-2"></i>Family Details</h6>
                        <Table borderless size="sm">
                            <tbody>
                                <tr><td className="text-muted font-weight-bold pl-0" style={{ width: '40%' }}>Father's Name</td><td className="text-dark">: {student?.father_name && student.father_name !== "-" ? student.father_name : "—"}</td></tr>
                                <tr><td className="text-muted font-weight-bold pl-0">Father's Contact</td><td className="text-dark">: {student?.father_phone && student.father_phone !== "-" ? student.father_phone : (student?.father_mobile && student.father_mobile !== "-" ? student.father_mobile : "—")}</td></tr>
                                <tr><td className="text-muted font-weight-bold pl-0">Mother's Name</td><td className="text-dark">: {student?.mother_name && student.mother_name !== "-" ? student.mother_name : "—"}</td></tr>
                                <tr><td className="text-muted font-weight-bold pl-0">Mother's Contact</td><td className="text-dark">: {student?.mother_phone && student.mother_phone !== "-" ? student.mother_phone : (student?.mother_mobile && student.mother_mobile !== "-" ? student.mother_mobile : "—")}</td></tr>
                            </tbody>
                        </Table>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default StudentProfileRecords;
